<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Create Step</span>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field label="Title">
                                    <b-input v-model="data.name"></b-input>
                                </b-field>
                                <b-field label="App">
                                    <app-filter v-model="data.application_id" expanded placeholder="Select application" />
                                </b-field>
                                <b-field label="Topic">
                                    <b-select placeholder="Select a topic" v-model="data.topic_id" expanded>
                                        <option :value="null">Select a topic</option>
                                        <option
                                            v-for="option in topics"
                                            :value="option.id"
                                            :key="option.id">
                                            {{ option.attributes.title }}
                                        </option>
                                    </b-select>
                                </b-field>
                                <section class="m-t-md">
                                    <router-link :to="{ name: 'guide' }" class="button is-default m-r-sm">Cancel</router-link>
                                    <b-button type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                                </section>
                            </div>
                            <div class="column is-half">
                                <b-upload v-model="file" class="m-b-sm" @input="onFileChange()">
                                    <a class="button is-primary">
                                        <b-icon icon="upload"></b-icon>
                                        <span>Upload Image</span>
                                    </a>
                                </b-upload>
                                <img :src="image" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import appFilter from '../../../../../components/AppFilter.vue'

export default {
    name:"StepCreate",
    components:{
        appFilter
    },
    data() {
        return {
            data:{
                name:null,
                topic_id:null,
                status:null,
                data:null,
                application_id:null
            },
            file:null,
            topics:[],
            page:1,
            image:null,
            steps:[],
            id:null
        }
    },
    computed:{
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
    },
    mounted() {
        this.data.application_id = this.$store.state.guide_application_id;
        this.data.topic_id = this.$store.state.guideTopicId;
    },
    watch: {
        "data.application_id"() {
            this.getTopics();
        },
    },
    methods: {
        async save() {

            if ( ! this.file) {
                this.$buefy.toast.open({
                    type:'is-danger',
                    message:'The image field is required.'
                });
                return;
            }

            try {
                this.loading = true

                const response = await Vue.$stepService.create({
                    name:this.data.name,
                    topic_id:this.data.topic_id,
                    application_id:this.data.application_id,
                    status:true
                });

                let formData = new FormData();
                if (this.file) {
                    formData.append('image',this.file);
                }
                this.id = response.data.id
                await Vue.$stepService.uploadFile(response.data.id,formData)

                this.$buefy.toast.open({
                    type:'is-success',
                    message:'Step created!'
                })
                this.$router.push({
                    name:`guide`,
                    query:{
                        tabSelected:'steps'
                    }
                })
            } catch (err) {
                // 
            } finally {
                this.loading = false;
            }
        },
        onFileChange() {
            this.image = URL.createObjectURL(this.file);
        },
        getTopics(){
            Vue.$topicService.topicList(`?application_id=${this.data.application_id}&without_steps=true`).then((response)=>{
                this.topics = response.data
            })
        }
    }
}
</script>